<template>
	<div class="loadItem">
		<div v-if="load.notes.length > 0 && !isListItems">
			<main-table
					padding="0"
					:flag="flag"
					:headers="getHeaders"
					:listItems="getListItems"
					@updateClickButton="onClickButton($event, flag)"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>
	</div>
</template>
<script>
// Constants
import { PAGE } from "@/constants/constants";
import { tableNotesView } from "@/components/Dispatch/Trips/DialogTrip/constants";

export default {
	name: "NotesView",
	props: {
		load: Object,
	},
	computed: {
		getHeaders() {
			return tableNotesView;
		},
		getListItems() {
			const noDel = this.load.notes.filter(obj => obj.status !== 'delete');

			for (let i = 0; i < noDel.length; i++) {
				if (noDel[i].created_at === noDel[i].edit_at) {
					noDel[i].edit_at = "";
				}
			}

			return noDel;
		},
		isListItems() {
			return this.load.notes.every(item => item.status === "delete");
		},
	},
	data() {
		return {
			flag: PAGE.TRIP_NOTES,
			list: null,
		};
	},
	methods: {
		onClickButton({ key, item }, nameComponent) {
			this.$emit('updateEditItem', { key, item, nameComponent });
		},
	},
};
</script>
<style lang="scss">
.loadMain {
	.pagination {
		padding: 20px 0 10px;
	}
}
</style>
<style scoped lang="scss">

</style>
